import { Command } from '../command.js';
import {Object3D, ObjectLoader,Group} from 'three';

/**
 * @param editor Editor
 * @param object THREE.Object3D
 * @constructor
 */
const loader = new ObjectLoader();
class CombineCommand extends Command {
	object:Object3D;
	childrenList: Object3D[];
	group: Group;
	constructor( editor, object ) {

		super( editor );

		this.type = 'CombineCommand';

		this.object = object;

		this.childrenList = []
		this.object.children.forEach(item=>{
			this.childrenList.push(item)
		})

		this.group = editor.createGroup(true);

		if ( object !== undefined ) {

			this.name = 'Combine';

		}

	}

	execute() {
		let idList = []
		let length = this.object.children.length;
		this.group.children = []
		// 减去原点的偏差值
		for(let i = length - 1; i >= 0; i--){
			idList.push(this.object.children[i].id)
			let item = loader.parse(this.object.children[i].clone().toJSON())
			this.group.add(item)
		}
		this.group.position.set(this.object.position.x, this.object.position.y, this.object.position.z)
		console.info(this.group)
		console.info(idList)
		this.editor.addObject( this.group );
		this.editor.select( this.group );
		// 删除选中模型
		idList.forEach(item=>{
			this.editor.removeObject(this.editor.scene.getObjectById(item))
		})
	}

	undo() {
		let objects = []
		console.log(this.childrenList)
		this.childrenList.forEach(item=>{
			console.log('undo',item)
			let newObject = item.clone();
			newObject.uuid = item.uuid
			newObject.position.set(
				this.group.position.x + newObject.position.x,
				this.group.position.y + newObject.position.y,
				this.group.position.z + newObject.position.z
			)
			this.editor.scene.add(newObject)
			objects.push(newObject)
		})
		this.editor.selectAll(objects)

		this.editor.removeObject( this.editor.scene.getObjectById(this.group.id) )
	}

}

export { CombineCommand };
